import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import PortingStatus from '../components/phone/PortingStatus';
import PortingDocumentUploader from '../components/phone/PortingDocumentUploader';
import CallRoutingSettings from '../components/phone/CallRoutingSettings';
import TestCallPanel from '../components/phone/TestCallPanel';

const PhoneNumberDetails = () => {
  const { id } = useParams<{ id: string }>();
  const [phoneNumber, setPhoneNumber] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPhoneNumber = async () => {
      try {
        const response = await api.get(`/phone-numbers/${id}`);
        setPhoneNumber(response.data);
      } catch (error) {
        console.error('Failed to fetch phone number details', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPhoneNumber();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!phoneNumber) {
    return <div>Phone number not found.</div>;
  }

  return (
    <div className="p-8 text-white">
      <h1 className="text-3xl font-bold mb-4">
        Manage: {phoneNumber.friendlyName || phoneNumber.number}
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <h2 className="text-2xl font-semibold mb-4">Porting</h2>
          {phoneNumber.portingRequest ? (
            <>
              <PortingStatus
                portingRequestId={phoneNumber.portingRequest.id}
                organizationId={phoneNumber.organizationId}
              />
              <div className="mt-4">
                <PortingDocumentUploader
                  phoneNumberId={id!}
                  onUploadSuccess={(doc) => {
                    // Refresh data or update state
                    setPhoneNumber({
                      ...phoneNumber,
                      portingRequest: {
                        ...phoneNumber.portingRequest,
                        documents: [...phoneNumber.portingRequest.documents, doc],
                      },
                    });
                  }}
                />
              </div>
            </>
          ) : (
            <p>This number is not currently being ported.</p>
          )}
        </div>
        <div>
          <h2 className="text-2xl font-semibold mb-4">Configuration</h2>
          <div className="space-y-4">
            <CallRoutingSettings
              phoneNumberId={id!}
              initialRules={phoneNumber.forwardingRules || []}
            />
            <TestCallPanel defaultNumber={phoneNumber.number} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneNumberDetails;
